import { useState } from 'react';
import { CoordinatePickerModal } from './coordinate-picker-modal.jsx';

/**
 * Drop-in button + modal for coordinate-input fields. Use anywhere a form
 * has lat/lon inputs:
 *
 *   <PickOnMapButton
 *     latitude={values.latitude}
 *     longitude={values.longitude}
 *     onChange={(lat, lon) => setValues(p => ({ ...p, latitude: lat, longitude: lon }))}
 *     title="Node location"
 *   />
 *
 * The button looks like a chip — discreet, sits next to the inputs.
 */
export function PickOnMapButton({ latitude, longitude, onChange, title, disabled, className }) {
  const [open, setOpen] = useState(false);
  const initial =
    Number.isFinite(Number(latitude)) && Number.isFinite(Number(longitude))
      ? { lat: Number(latitude), lon: Number(longitude) }
      : null;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        disabled={disabled}
        className={
          'inline-flex items-center gap-1.5 rounded-xl border border-line bg-white px-3 py-1.5 text-xs font-semibold text-accent shadow-card transition-colors hover:bg-accent-soft disabled:cursor-not-allowed disabled:opacity-50 ' +
          (className || '')
        }
      >
        <i className="fa-solid fa-location-dot text-[11px]" aria-hidden="true" />
        Pick on map
      </button>

      <CoordinatePickerModal
        open={open}
        initial={initial}
        title={title || 'Pick a location'}
        onClose={() => setOpen(false)}
        onPick={(lat, lon) => onChange?.(lat, lon)}
      />
    </>
  );
}
